import React, { useState, useEffect, Fragment } from 'react';
import {
    Row, Card, CardBody, Button,
    ButtonDropdown,
    UncontrolledDropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
    CustomInput,
    Collapse
} from 'reactstrap';
import { Colxx, Separator } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import { gAPI_Locations } from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import LocationListItem from "./components/LocationListItem";
import LocationForm from "./components/LocationForm";
import IntlMessages from "../../../../../helpers/IntlMessages";



function Index({ propertyId }) {
    const [locationList, setLocationsList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [visible, setVisible] = useState(false);
    const [orderBy, setOrderBy] = useState({ column: "Name", label: "Name" });
    const [search, setSearch] = useState('');
    const orderOptions = [
        { column: "Name", label: "Name" },
        { column: "Address", label: "Address" },
        { column: "City", label: "City" },
        { column: "Status", label: "Status" }
    ]
    useEffect(() => {
        LoadData();
    }, [propertyId, orderBy, search]);

    const LoadData = () => {
        AxiosAPI({
            methhod: 'get',
            url: `${gAPI_Locations}?propertyId=${propertyId}&orderBy=${
                orderBy.column}&search=${search}`,
        })
            .then(res => {
                setLocationsList(res.data);
                setLoading(false);
            })
            .catch(err => console.log('err', err));
    }

    const toggleModal = () => {
        setVisible(!visible)
    };

    const changeOrderBy = column => {
        setOrderBy(orderOptions.find(
            x => x.column === column
        ))
    };

    const onSearchKey = e => {
        if (e.key === "Enter") {
            setSearch(e.target.value.toLowerCase())
        }
    };

    if (loading) {
        return (
            <div className="loading" />
        );
    }

    return (
        <Fragment>
            <Row className="app-row survey-app">
                <Colxx xxs="12">
                    <div className="mb-2">
                        <h1>
                            Locations
              </h1>
                        {!loading && (
                            <Fragment>
                                <div className="text-zero top-right-button-container">
                                    <Button
                                        color="primary"
                                        size="lg"
                                        className="top-right-button mr-1"
                                        onClick={toggleModal}
                                    >
                                        Add New
                                </Button>
                                </div>
                            </Fragment>
                        )}
                    </div>
                    <div className="mb-2">
                        <div className="d-block d-md-inline-block">
                            <UncontrolledDropdown className="mr-1 float-md-left btn-group mb-1">
                                <DropdownToggle caret color="outline-dark" size="xs">
                                    <IntlMessages id="pages.orderby" />
                                    {orderBy.label}
                                </DropdownToggle>
                                <DropdownMenu>
                                    {orderOptions.map((order, index) => {
                                        return (
                                            <DropdownItem
                                                key={index}
                                                onClick={() => changeOrderBy(order.column)}
                                            >
                                                {order.label}
                                            </DropdownItem>
                                        );
                                    })}
                                </DropdownMenu>
                            </UncontrolledDropdown>
                            <div className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top">
                                <input
                                    type="text"
                                    name="keyword"
                                    id="search"
                                    placeholder="Search"
                                    onKeyPress={e => onSearchKey(e)}
                                />
                            </div>
                        </div>
                    </div>
                </Colxx>
            </Row>
            <Separator className="mb-5" />
            <Row>
                {!loading ? (
                    locationList.map((item, index) => {
                        return (
                            <LocationListItem
                                key={`location_item_${index}`}
                                item={item}
                                toggleModal={toggleModal}
                            />
                        );
                    })
                ) : (
                        <div className="loading" />
                    )}
            </Row>

            <LocationForm
                toggleModal={toggleModal}
                formLabel="Create a New Location"
                visible={visible}
            />
        </Fragment>
    );
}

const mapStateToProps = ({ settings }) => {
    const { propertyId } = settings;
    return {
        propertyId,
    };
};

export default injectIntl(connect(mapStateToProps, {})(Index));
